exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".margin-left-2[data-v-63fbb93a]{margin-left:4px}.margin-left-2[data-v-63fbb93a]:first-child{margin-left:0}", ""]);

// exports
